import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./tabs.css.ts.vanilla.css-mistica.js";
var v = "_1y2v1nfb4 _1y2v1nfb0 _1y2v1nfeq _1y2v1nffk _1y2v1nfcb _1y2v1nf45", y = "lgofm1g", _ = "lgofm13", a = "lgofm12 _1y2v1nfdg _1y2v1nfbs _1y2v1nfaz", e = "lgofm10", o = {
    noSelected: "_1y2v1nf1y",
    selected: "_1y2v1nf1w lgofm1b",
    selectedAnimating: "_1y2v1nf1w lgofm1c"
}, r = {
    default: "lgofm16 _1y2v1nf8w _1y2v1nfa5 _1y2v1nfb6 _1y2v1nfbn _1y2v1nfbk _1y2v1nfbe _1y2v1nfd4 _1y2v1nfdg _1y2v1nf5y",
    fullWidth: "lgofm18 lgofm16 _1y2v1nf8w _1y2v1nfa5 _1y2v1nfb6 _1y2v1nfbn _1y2v1nfbk _1y2v1nfbe _1y2v1nfd4 _1y2v1nfdg _1y2v1nf5y"
}, t = "_1y2v1nfdg _1y2v1nfbs _1y2v1nfb5";
export { v as animatedLine, y as icon, _ as inner, a as outer, e as outerBorder, o as tabSelectionVariants, r as tabVariants, t as tabsContainer };
